import axios from 'axios';

// 获取应付账款列表
export const getPayables = (params?: { storeId?: string | number; status?: string }) =>
  axios.get('/api/payables', { params });

// 获取应付账款统计
export const getPayablesStats = (storeId?: string | number) =>
  axios.get('/api/payables/stats', { params: { storeId } });

// 记录付款
export const recordPayablePayment = (
  payableId: number,
  data: {
    payment_amount: number;
    payment_method?: string;
    payment_date?: string;
    check_no?: string;
    check_exchange_date?: string;
    notes?: string;
    store_id?: number;
  }
) => axios.post(`/api/payables/${payableId}/payment`, data);

export const createPayable = (
  data: {
    store_id: number;
    supplier_id?: number | string;
    supplier_name?: string;
    po_number?: string;
    amount: number;
    due_date?: string;
    notes?: string;
  }
) => axios.post('/api/payables', data);

// 获取应收账款预警计数
export const getReceivableAlerts = (storeId: number) =>
  axios.get(`/api/stores/${storeId}/receivables/alerts`).then((r) => r.data?.data);

// 获取支票汇总统计（含预警）
export const getChecksSummary = (storeId: number) =>
  axios.get(`/api/stores/${storeId}/checks/summary`).then((r) => r.data?.data);
